import { SITE_URL } from './config/site'

export const GOOGLE_ANALYTICS_ID = 'G-F7YCPE5E0R'

type AnalyticsWindow = Window & {
  dataLayer?: unknown[][]
  gtag?: (...args: unknown[]) => void
}

export function shouldEnableAnalytics(currentOrigin: string, automated: boolean | undefined, productionOrigin = new URL(SITE_URL).origin) {
  return currentOrigin === productionOrigin && automated !== true
}

export function initializeAnalytics(browserWindow: Window, browserDocument: Document, automated: boolean | undefined) {
  const disableKey = `ga-disable-${GOOGLE_ANALYTICS_ID}`
  const analyticsWindow = browserWindow as AnalyticsWindow

  if (!shouldEnableAnalytics(browserWindow.location.origin, automated)) {
    ;(browserWindow as unknown as Record<string, unknown>)[disableKey] = true
    return false
  }

  analyticsWindow.dataLayer = analyticsWindow.dataLayer ?? []
  // eslint-disable-next-line prefer-rest-params
  analyticsWindow.gtag = function() { analyticsWindow.dataLayer!.push(arguments as unknown as unknown[]) }
  analyticsWindow.gtag('js', new Date())
  analyticsWindow.gtag('config', GOOGLE_ANALYTICS_ID)

  const tag = browserDocument.createElement('script')
  tag.async = true
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`
  tag.dataset.stayinbrowserAnalytics = 'production'
  browserDocument.head.append(tag)
  return true
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  initializeAnalytics(window, document, navigator.webdriver)
}
